"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConsoleLogger_1 = require("./ConsoleLogger");
var MetricType;
(function (MetricType) {
    MetricType["Gauge"] = "gauge";
    MetricType["Increment"] = "increment";
    MetricType["Timing"] = "timing";
})(MetricType = exports.MetricType || (exports.MetricType = {}));
var getLogger = function () {
    return window.MetricLogger
        ? window.MetricLogger
        : new ConsoleLogger_1.ConsoleLogger({ prefix: 'xplan' });
};
/**
 * Higher order which optionally accepts a callback handler to log metric information.
 * If `options.type` is not specified it will default log increment metric.
 */
exports.trackMetric = function (options, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (options) {
            if (!options.type) {
                options.type = MetricType.Increment;
            }
            getLogger()[options.type](options.metricKey, options.value);
        }
        if (fn) {
            fn.apply(void 0, args);
        }
    };
};
/**
 * Higher order which optionally accepts a callback handler to log 'increment'
 * metric information.
 */
exports.trackIncrementMetric = function (options, fn) {
    options.type = MetricType.Increment;
    return exports.trackMetric(options, fn);
};
/**
 * Higher order which optionally accepts a callback handler to log 'timing'
 * metric information.
 */
exports.trackTimingMetric = function (options, fn) {
    options.type = MetricType.Timing;
    return exports.trackMetric(options, fn);
};
/**
 * Higher order which optionally accepts a callback handler to log 'gauge'
 * metric information.
 */
exports.trackGaugeMetric = function (options, fn) {
    options.type = MetricType.Gauge;
    return exports.trackMetric(options, fn);
};
//# sourceMappingURL=trackMetric.js.map